import React, { Component } from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import normalizeCss from "normalize.css";
import bootstrapCss from "bootstrap/dist/css/bootstrap.css";
import pagTableStyles from "react-table/react-table.css";
import fullCalendarBaseStyles from "fullcalendar/dist/fullcalendar.min.css";
import reactTostifyStyles from "react-toastify/dist/ReactToastify.min.css";
import reactTimesCss from "react-times/css/classic/default.css";
import rcTreeStyles from "rc-tree/assets/index.css";
import s from "./OBLayout.styles.scss";
import logo from "../../media/images/sports_logo.png";
import OBNotification from "../OBNotification/OBNotification.component";
import { obLayoutStore } from "./OBLayout.store";
import { ReduxConnect } from "../../../toolkit/decorators/Artifact";
import { _OB_SUBTITLE, _OB_TITLE } from "./OBLayout.utils";

interface Props {
  title?: string;
  subTitle?: string;
  children: React.ReactNode;
}

interface State {}

@ReduxConnect(obLayoutStore, () => {})
class OBLayoutUnstyled extends Component<Props, State> {
  componentDidMount(): void {
    document.title = this.props.title || _OB_TITLE || "Sports World";
  }

  render() {
    return (
      <div className={s.layoutRoot}>
        <OBNotification {...({} as any)} />
        <div className={s.header}>
          <img src={logo} alt="Sports World" />
        </div>
        <div className={s.title}>{this.props.title || _OB_TITLE}</div>
        <div className={s.subTitle}>{this.props.subTitle || _OB_SUBTITLE}</div>
        <div className={s.content}>{this.props.children}</div>
      </div>
    );
  }
}

const OBLayout = withStyles(
  normalizeCss,
  bootstrapCss,
  pagTableStyles,
  reactTostifyStyles,
  fullCalendarBaseStyles,
  reactTimesCss,
  rcTreeStyles,
  s
)(OBLayoutUnstyled);

export default OBLayout;
